import React from 'react';
// import {injectStripe} from 'react-stripe-elements';
// import React from 'react';
import {
  Field,
  reduxForm,
} from 'redux-form';

import {
  StyledForm,
  FormButtonGroup,
  ColMd6,
  ColMd12,
  Row,
  FormHeading,
} from './styledComponents';
import A from 'components/A';
import Button from 'components/Button';
import InputField from 'components/InputField';
import CardSection from './CardSection';
import { connect } from 'react-redux';
import Icon from 'components/Icon';
import { Link } from 'react-router-dom';
import StyledSpinner from 'components/StyledSpinner/index.js'

const required = value => value ? undefined : 'Required'

let CheckoutForm = ({
  handleSubmit,
  planId,
  canSubmit,
  change,
  errorMessage,
  paying,
}) => {
  return (
     <StyledForm id="payment-form" onSubmit={handleSubmit}>
     <FormHeading>
        <strong>Billing Info</strong>
        <span>
          <em>secure checkout with </em>
          <a href='//stripe.com/' target="_blank" >
            <Icon
              size='140'
              width='38px'
              height='16px'
              name='stripe'
              viewBox='0 0 30 20'
            />
            </a> 
        </span>
      </FormHeading>
      <Row>
        <ColMd6>
          <Field
            name='firstname'
            type='text'
            component={InputField}
            label='FIRST NAME'
            placeholder='enter your first name'
            validate={[ required ]}
          />
        </ColMd6>
        <ColMd6>
          <Field
            name='lastname'
            type='text'
            component={InputField}
            label='Last Name'
            placeholder='nter your last name'
            validate={[ required ]}
          />
        </ColMd6>
        <ColMd6>
          <Field
            name='phone'
            type='text'
            component={InputField}
            label='PHONE'
            placeholder='(xxx) xxx-xxxx'
            validate={[ required ]}
          />
        </ColMd6>
        <ColMd6>
          <Field
            name='promocode'
            type='text'
            component={InputField}
            label='PROMO CODE'
            placeholder='enter a promo code'
          />
        </ColMd6>
      </Row>
      <span><p style={{color: 'red'}}>{errorMessage}</p></span>
      <Row>
        <ColMd12>
         <CardSection setHiddenToken={(token) => change('token', token)}/>
        </ColMd12>
      </Row>
      <Row>
        <ColMd12>
          <Field
            name='planId'
            type="hidden"
            component="input"
          />
          <Field
            name='token'
            type="hidden"
            component="input"
          />
        </ColMd12>
                </Row>
      <FormButtonGroup>
        { paying 
          ?
          <StyledSpinner />
          :
          <Button type='submit' disabled={!canSubmit}>
              Pay Now
          </Button>
        }
      </FormButtonGroup>
    </StyledForm>
  );
}
const mapStateToProps = (state, ownProps) =>({
  canSubmit: state.niceChoice.canSubmit,
  initialValues: {
    planId: ownProps.planId
  },
  errorMessage: state.niceChoice.errorMessage,
  paying: state.niceChoice.paying,
});

CheckoutForm = reduxForm({
  form: 'Checkout',
})(CheckoutForm);

export default connect(
  mapStateToProps,
  null
)((CheckoutForm));



// WEBPACK FOOTER //
// ./src/containers/NiceChoice/CheckoutForm.js